import axios from 'axios'
export default {
  namespaced: true,
  state() {
    return {
      item: null,
      loaded: false,
      showed: false,
      token: null
    }
  },
  mutations: {
    set_prop(state, data) { state[data.key] = data.v; }, // key, v
    set_loaded: (state, v) => { state.loaded = v; },
    set_showed: (state, v) => { state.showed = v; },
    set_item(state, v) { state.item = v; },
    set_token(state, v) { state.token = v; }
  },
  actions: {
    load(context, id) {
      let token = context.state.token;
      context.commit('set_loaded', false);
      return axios.put(`1.0/interviews/${token}/tests/questions/${id}/show`).then(r => {
        context.commit('set_item', r.data.data[0]);
        context.commit('set_loaded', true);
      })
    },
    show_media(context, id) {
      let token = context.state.token;
      context.commit('set_loaded', false);
      return axios.put(`1.0/interviews/${token}/tests/questions/${id}/media/show`).then(r => {
        context.commit('set_item', r.data.data[0]);
        context.commit('set_showed', true);
      })
    },
    start_media(context, id) {
      let token = context.state.token;
      return axios.put(`1.0/interviews/${token}/tests/questions/${id}/media/play`)
    }
  },
  getters: {
    item(state) { return state.item },
    token(state) { return state.token },
    loaded(state) { return state.loaded },
    showed(state) { return state.showed }
  }
}